import { render, staticRenderFns } from "./WelcomeCard.vue?vue&type=template&id=436af618&scoped=true"
import script from "./WelcomeCard.vue?vue&type=script&lang=js"
export * from "./WelcomeCard.vue?vue&type=script&lang=js"
import style0 from "./WelcomeCard.vue?vue&type=style&index=0&id=436af618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436af618",
  null
  
)

export default component.exports